import './styles.scss';
import React, {Dispatch, useEffect, useState} from "react";

/* Types, Constants, Utils */
import * as Constants from "../../../constants";
import Utils from "../../../utils";

/* Redux */
import {useDispatch, useSelector} from "react-redux";
import {ISearchDate, ISearchState} from "../../../types/redux/search";
import {RootState} from "../../../redux";

/* Bootstrap */
import {Button} from "react-bootstrap";
import {TFilterOption} from "../../../types/search";
import {addFilters, removeDate, removeFilters} from "../../../redux/slices/search-slice";
import {AnyAction} from "@reduxjs/toolkit";
import {TAdvSearchDate} from "../../../constants";

const FiltersApplied = ():JSX.Element => {
  /* redux */
  const dispatch:Dispatch<AnyAction> = useDispatch();
  const searchState: ISearchState = useSelector<RootState, ISearchState>(state => state.search);

  /* state */
  const [filterButtons, setFilterButtons] = useState<TFilterOption[]>([])
  const [datesButtons, setDatesButtons] = useState<ISearchDate[]>([]);

  useEffect(()=>{
    const visibleFilters: TFilterOption[] = [];
    searchState.applied_filters.forEach((filter:TFilterOption) => {
      visibleFilters.push(filter);
    });

    setFilterButtons(visibleFilters);

    const dateFilters: ISearchDate[] = searchState.dates.filter((date:ISearchDate) =>{
      return !Constants.ADV_SEARCH_DATES.find((advDate:TAdvSearchDate) => date.id === advDate.id)
    });

    setDatesButtons(dateFilters);
  }, [searchState.applied_filters, searchState.db_set, searchState.dates])

  const removeFilter = (filterOption: TFilterOption): void => {
    if (filterOption.invert) {
      dispatch(addFilters([filterOption]))
    } else {
      dispatch(removeFilters([filterOption]))
    }
  }

  const removeDateFilter = (id: string): void => {
    const filterOption: TFilterOption = searchState.available_filter_options.find(f=>f.id === id)
    dispatch(removeFilters([filterOption]));
    dispatch(removeDate(filterOption.id))
  }

  return (
    <div className={'filters-applied d-flex flex-wrap py-1 pb-lg-0 pt-lg-2'}>
      {filterButtons.map(filterOption=>{
        return (
          <div className={'btn-container rounded bg-grey-lighter ms-2 position-relative text-smaller d-flex mt-1 mb-1'}  key={'sl_' + filterOption.id }>
            <p className={'name ellipse'}>{(filterOption.label === Utils.toTitleCase(Constants.SELECT_ALL)) ? filterOption.value : filterOption.label}</p>
            <Button
              className={'close-btn border-0 btn-icon-only'}
              onClick={()=>removeFilter(filterOption)}
            >
              <i className={'ms-1 mbi bi-x text-black'}/>
            </Button>
          </div>
        )
      })}

      {datesButtons.map((date: ISearchDate, index:number)=>{
        return (
          <div className={'btn-container rounded bg-grey-lighter ms-2 position-relative text-smaller d-flex mt-1 mb-1'}  key={'dt_'+ index}>
            <p className={'name ellipse'}>{date.id !== Constants.NO_DATE ? (date.to.split('/').pop()) : Utils.toTitleCase(Constants.NO_DATE)}</p>
            <Button
              className={'close-btn border-0 btn-icon-only'}
              onClick={()=>removeDateFilter(date.id)}
            >
              <i className={'ms-1 mbi bi-x text-black'}/>
            </Button>
          </div>
        )
      })}
    </div>


  )
}
export default FiltersApplied;
